import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { coercedDate } from '../../../utils/coerced-date';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { vehicleDriverLinkSchema } from '../schemas/vehicle-driver-link.schema';

/**
 * Returns the Driver Vehicle Links for a Vehicle-Based Account
 * @param vehicleIds The IDs of the Vehicles being requested
 * @returns The Driver Vehicle Link
 */
export function postVehiclesDriverLinks(this: unknown, vehicleIds: string[]) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).vehiclesDriverLinksUrl, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify({ vehicleIds }),
      })
    )
  ).pipe(
    selectData(
      z.object({
        message: z.string().nullable(),
        data: z.object({
          lastModifiedOn: coercedDate.optional(),
          vehicleDriverLinkDetails: z.array(vehicleDriverLinkSchema),
        }),
        error: z
          .object({
            message: z.string().optional(),
            detail: z.string().optional(),
            errorCode: z.number(),
          })
          .optional(),
      })
    )
  );
}
